import "@/config/amplify";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import SignIn from "./auth/SignIn";
import { ForgotPassword } from "./auth/ForgotPassword";
import { UpdatePassword } from "./auth/UpdatePassword";
import { Toaster } from "@/components/ui/sonner";
import {
  authMiddleware,
  guestOnlyMiddleware,
  signInMiddleware,
} from "./middleware/auth-middleware";
import PageNotFound from "@/components/not-found/pageNotFound";
import ProtectedLayout from "./ProtectedLayout";
import SuggestedRatesPage from "@/components/SuggestedRatesPage";

const router = createBrowserRouter([
  {
    path: "/sign-in",
    loader: signInMiddleware,
    element: <SignIn />,
  },
  {
    path: "/forgot-password",
    loader: guestOnlyMiddleware,
    element: <ForgotPassword />,
  },
  {
    path: "/update-password",
    loader: guestOnlyMiddleware,
    element: <UpdatePassword />,
  },
  {
    path: "/",
    loader: authMiddleware,
    element: <ProtectedLayout />,
    errorElement: <PageNotFound />,
    children: [
      { index: true, element: <SuggestedRatesPage /> },
      { path: ":hotelId", element: <SuggestedRatesPage /> },
    ],
  },
  {
    path: "*",
    element: <PageNotFound />,
  },
]);

const App = () => {
  return (
    <>
      <Toaster />
      <RouterProvider router={router} />
    </>
  );
};

export default App;
